'use strict';

exports.__esModule = true;
exports.phasesConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.create = create;
exports.reportAppLoadStarted = reportAppLoadStarted;

var _fedopsPresets = require('@wix/fedops-presets');

var _env = require('./env');

var _conf = require('./conf');

var _reporterFactory = require('./reporter/reporter-factory');

var _baseLogger = require('./base-logger');

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _globalAppData = require('./global-app-data/global-app-data');

var _sessionManager = require('./session-manager/session-manager');

var _sessionManager2 = _interopRequireDefault(_sessionManager);

var _performance = require('./performance/performance');

var _performance2 = _interopRequireDefault(_performance);

var _loadingPhasesConfig = require('./loading-phases/loading-phases-config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAppVersion() {
  return (0, _env.env)().__CI_APP_VERSION__ || _conf.DEFAULT_APP_VERSION;
}

/*
 * @param baseUrl
 * @param appId
 * @param disableAutoLoadFinish
 * @param interactionTimeout
 * @param timeoutHook
 * @param startHook
 * @param endHook
 * @param biLoggerFactory
 * @param endpoint
 * @param endpoint artifactData
 */
function create(appName) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!appName) {
    return null;
  }
  var appNameWithoutDots = appName.replace(/\./g, '-');

  (0, _globalAppData.initializeGlobal)(appNameWithoutDots);

  var fullParams = _extends({}, params, { preset: (0, _fedopsPresets.presetLoader)(params.presetType) });
  var reporter = (0, _reporterFactory.create)(fullParams);

  return new _baseLogger2.default(appNameWithoutDots, getAppVersion(), reporter, fullParams);
}

/**
 * Report application started loading
 * @param {string} appName Application/Dashboard name
 * @param {{artifactData}} artifact data
 */
function reportAppLoadStarted(appName) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      artifactData = _ref.artifactData;

  (0, _globalAppData.initializeGlobal)(appName);
  (0, _globalAppData.setLoadStartTime)(appName, _performance2.default.responseEndTime() || _performance2.default.now());

  var sessionId = _sessionManager2.default.getSessionId();
  (0, _globalAppData.setSessionId)(sessionId);

  var url = '//frog.wix.com/fed?appName=' + appName + '&src=72&evid=14&session_id=' + sessionId + '&_=' + Math.random();

  if (artifactData) {
    url += '&artifactId=' + artifactData.id + '&artifactVersion=' + artifactData.version + '&isRollout=' + artifactData.isRollout;
  }

  if ((0, _env.hasSendBeacon)()) {
    (0, _env.sendBeacon)(url);
  } else {
    new Image().src = url;
  }
}

var phasesConfig = exports.phasesConfig = _loadingPhasesConfig.phasesConfigValues;